module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Duels.7d83b9e2.svg";